import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { Button, Heading, Text } from "nectar-ui";
import { NectarTheme } from "../../../../typings/theme";

export const EmptyStateWrapper = styled.div`
  ${({ theme }: NectarTheme) => css`
    max-width: 1012px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: ${theme.spacings.lg};
    align-self: stretch;
  `}
`;

export const TextWrapper = styled.div`
  ${({ theme, mobile }: { theme: NectarTheme["theme"]; mobile: boolean }) => `
    width: ${mobile ? "296px" : "416px"};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
  `}
`;

export const StyledHeading = styled(Heading)`
  letter-spacing: normal !important;
  margin: 0 !important;
  line-height: 140% !important;
`;

export const StyledText = styled(Text)`
  margin: 0 !important;
  line-height: 140% !important;
`;

export const StyledLinkButton = styled(Button)`
  ${({ theme }: NectarTheme) => `
    font-size: ${theme.typography.text.sm};
    margin-bottom: ${theme.spacings.xs};
  `}
`;
